// discover layout
export const GET_EXPERIENCE_ID = {
  LOADING: 'getExperienceIDLoading',
  SUCCESS: 'getExperienceIDSuccess',
  FAIL: 'getExperienceIDFail'
};

export const GET_E_AGENT_PRODUCT = {
  LOADING: 'getEAgentProductLoading',
  SUCCESS: 'getEAgentProductSuccess',
  FAIL: 'getEAgentProductFail'
};

export const GET_E_PRODUCT_BANNER = {
  LOADING: 'getEProductBannerLoading',
  SUCCESS: 'getEProductBannerSuccess',
  FAIL: 'getEProductBannerFail'
};

export const GET_E_PRODUCT_LIST = {
  LOADING: 'getEProductListLoading',
  SUCCESS: 'getEProductListSuccess',
  FAIL: 'getEProductListFail',
  NEXT_LOADING: 'getNextEProductListLoading',
  NEXT_SUCCESS: 'getNextEProductListSuccess',
  NEXT_FAIL: 'getNextEProductListFail',
  SET_LIKE: 'setEProductListLike'
};

export const GET_E_PRODUCT_FEATURE = {
  LOADING: 'getEProductFeatureLoading',
  SUCCESS: 'getEProductFeatureSuccess',
  FAIL: 'getEProductFeatureFail'
};

export const INIT_EXPERIENCES = 'initExperiences';
